import { InputInputEventDetail, IonInputCustomEvent } from "@ionic/core";
import { IonButton, IonIcon, IonInput } from "@ionic/react";
import { add, remove } from "ionicons/icons";
import React, { FocusEventHandler, KeyboardEventHandler } from "react";
import { RouteProps } from "react-router";
import { hapticsImpactMedium } from "../../../utils/core-utils/hapticUtils";

interface TickComponentProps extends RouteProps {
  hideValue?: boolean;
  alternateStyle?: boolean;
  tickDisabled?: boolean;
  priceDisabled?: boolean;
  readOnly?: boolean;
  handleClick?: Function | undefined;
  handleChange?:
    | ((event: IonInputCustomEvent<InputInputEventDetail>) => void)
    | undefined;
  name: string;
  value: string | number | undefined;
  onKeyPressFunc?: KeyboardEventHandler<HTMLIonInputElement>;
  onKeyUpPressFunc?: KeyboardEventHandler<HTMLIonInputElement>;
  key?: string;
  errorFlag?: boolean;
  onBeforeInput?: (event: any) => void;
  onFocus?: FocusEventHandler<HTMLIonInputElement>;
  onFocusOut?: FocusEventHandler<HTMLIonInputElement>;
  inputMode?:
    | "none"
    | "text"
    | "tel"
    | "url"
    | "email"
    | "numeric"
    | "decimal"
    | "search";
}

const TickComponent: React.FC<TickComponentProps> = ({
  tickDisabled,
  priceDisabled,
  readOnly,
  handleClick,
  handleChange,
  name,
  value,
  onKeyPressFunc,
  onKeyUpPressFunc,
  errorFlag,
  onBeforeInput,
  onFocus,
  onFocusOut,
  inputMode,
}) => {
  let priceValue;
  if (priceDisabled === true) {
    priceValue = "";
  } else {
    priceValue = value;
  }
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "41px",
        border: priceDisabled
          ? "1px solid #363E46"
          : "1px solid rgba(255, 255, 255, 0.10)",
        backgroundColor: priceDisabled
          ? "#001624"
          : errorFlag
            ? "rgba(232, 61, 61, 0.086)"
            : "rgba(255, 255, 255, 0.05)",
      }}
    >
      <IonButton
        slot="icon-only"
        fill="clear"
        color={"dark"}
        disabled={tickDisabled}
        onClick={() => {
          handleClick && handleClick({ dir: "down", number: 1 });
          hapticsImpactMedium();
        }}
      >
        <IonIcon slot="icon-only" icon={remove}></IonIcon>
      </IonButton>
      <IonInput
        style={{
          width: "100%",
          minHeight: 0,
          textAlign: "center",
          fontSize: "var(--one-font-size-11)",
        }}
        type={
          name?.indexOf("Quantity") !== -1 || name?.indexOf("Qty") !== -1
            ? "number"
            : "text"
        }
        inputmode={
          inputMode
            ? inputMode
            : name?.indexOf("Quantity") !== -1 || name?.indexOf("Qty") !== -1
              ? "numeric"
              : "decimal"
        }
        name={name}
        onKeyDown={onKeyPressFunc}
        onKeyUp={onKeyUpPressFunc}
        value={priceValue}
        readonly={readOnly}
        disabled={priceDisabled}
        onIonInput={handleChange}
        onBeforeInput={onBeforeInput}
        onBlur={onFocusOut} // Use onBlur for focus out
        onFocus={onFocus}
      />
      <IonButton
        slot="icon-only"
        fill="clear"
        color={"dark"}
        disabled={tickDisabled}
        onClick={() => {
          handleClick && handleClick({ dir: "up", number: 1 });
          hapticsImpactMedium();
        }}
      >
        <IonIcon slot="icon-only" icon={add}></IonIcon>
      </IonButton>
    </div>
  );
};

export default TickComponent;
